import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from './Header';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AssignmentIcon from '@mui/icons-material/Assignment';

const OrderSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get order ID from location state
  const orderId = location.state?.orderId || '';

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-20">
        <div className="max-w-3xl mx-auto px-4 py-12">
          {/* Back Button */}
          <button 
            onClick={() => navigate('/products')} 
            className="flex items-center text-primary font-semibold hover:underline mb-8"
          >
            <ArrowBackIcon className="mr-2 !w-5 !h-5" />
            Back to Products
          </button>

          {/* Success Card */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="bg-green-600 text-white px-6 py-8 text-center">
              <CheckCircleIcon className="!w-20 !h-20 mx-auto mb-4" />
              <h1 className="text-3xl font-bold">Order Placed Successfully!</h1>
            </div>

            <div className="p-8">
              {/* Order ID */}
              <div className="bg-gray-50 rounded-lg p-6 mb-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <AssignmentIcon className="!w-8 !h-8 text-primary" />
                    <div>
                      <p className="text-sm text-gray-600">Your Order ID</p>
                      <p className="text-2xl font-bold text-primary">{orderId}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Instructions */}
              <div className="bg-blue-50 border-l-4 border-primary p-6 mb-6 rounded">
                <h2 className="text-lg font-bold text-primary mb-4">What's Next?</h2>
                <div className="space-y-3 text-gray-700">
                  <div className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-sm font-bold">1</span>
                    <p>Your order will be processed within <strong>1-3 working days</strong></p>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-sm font-bold">2</span>
                    <p>We will contact you via phone for order confirmation</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-sm font-bold">3</span>
                    <p>You can check your order status anytime using the "Check Order Status" button in the header</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-sm font-bold">4</span>
                    <p>Your payment receipt will be verified by our team</p>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={() => navigate('/products')}
                  className="flex-1 bg-primary hover:bg-blue-900 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                >
                  Continue Shopping
                </button>
                <button
                  onClick={() => {
                    navigate('/check-order-status');
                  }}
                  className="flex-1 bg-gray-500 hover:bg-gray-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                >
                  Check Order Status
                </button>
              </div>

              {/* Support Info */}
              <div className="mt-8 pt-6 border-t border-gray-200 text-center text-gray-600">
                <p className="text-sm">
                  Need help? Contact us at{' '}
                  <a href="mailto:info@mmkind.com.my" className="text-primary hover:underline">
                  industriesmmk@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;

